/** Статус доставки сообщения. */
export enum ClientMessageStatus {
    Pending = "pending",
    Sent = "sent",
    Delivered = "delivered",
    Read = "read",
    Failed = "failed",
}
